/**
 * @description 予約モジュール
 */
export function reservation(): void {
  const trsv = $('#trsv');
  const url = location.origin + '/common/reservation/index.html';

  $.ajax({
    url: url,
  })
    .done((data) => {
      $('head').prepend('<link href="https://d2ahiw9kb7is19.cloudfront.net/arthotelaomori/Assets/ArtHotelAomori/booking-engine/app.css?d=20250528120124" rel="stylesheet">');

      if (trsv.length) {
        trsv.append(data);
      } else {
        $('.body').prepend(data);
      }

      $('[data-rsvclose]').on('click', function () {
        if (trsv.length) {
          trsv.append($('.reserve-menu'));
        } else {
          $('.reserve-menu').hide();
        }
      });
      $('[data-rsv]').on('click', function () {
        if (trsv.length) {
          $('.body').prepend($('.reserve-menu'));
        }
        $('.reserve-menu').show();
        $('.menu').hide();
      });
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      console.error(`予約モジュール読み込みエラー: ${jqXHR.status}, ${textStatus}, ${errorThrown}`, jqXHR.responseText);
    });
}
